import React, { useCallback } from "react";
import { IMessage, AssignmentStatusEnum, SectionTypeEnum } from "@imaginelearning/mps-api-service";
import { UxAvatarEnum } from "@imaginelearning/mps-ux-component-library";
import ActivityTransitionModal from "../../modals/activity-transition/activity-transition-modal";

export enum TransitionActionEnum {
  CLOSE = "close",
  GO_BACK = "goBack",
  GET_NEXT_TOKEN = "getNextToken",
  GO_TO_HOME_PAGE = "goToHomePage"
}

export interface IActivityTransitionState {
  show: boolean;
  starsEarned: number;
  transitionMessage: string | IMessage[] | null;
  activityStatus: AssignmentStatusEnum;
  activityType: SectionTypeEnum;
  action: TransitionActionEnum;
  isLessonCompleted: boolean;
  totalScore: number | null;
  takeTotal: number;
  displayScore: boolean;
  onClose?: (action: TransitionActionEnum, isClosedUsingX?: boolean) => void;
}

interface IActivityTransitionManagerProps {
  state: IActivityTransitionState;
  avatar: UxAvatarEnum;
  onStateChange: (newState: IActivityTransitionState) => void;
}

const initialState: IActivityTransitionState = {
  show: false,
  starsEarned: 0,
  transitionMessage: null,
  activityStatus: AssignmentStatusEnum.NOT_STARTED,
  activityType: SectionTypeEnum.MASTERY_CHECK,
  action: TransitionActionEnum.CLOSE,
  isLessonCompleted: false,
  totalScore: 0,
  takeTotal: 0,
  displayScore: false,
  onClose: undefined
};

function ActivityTransitionManager({ state, avatar, onStateChange }: IActivityTransitionManagerProps) {
  const handleModalClose = useCallback(
    (close?: boolean) => {
      // Reset the state first
      onStateChange({ ...initialState });

      // Execute the callback if provided
      if (state.onClose) {
        // Determine if modal was closed using the X button
        const isClosedUsingX = close === true;
        const actionToPass = isClosedUsingX ? TransitionActionEnum.CLOSE : state.action;
        state.onClose(actionToPass, isClosedUsingX);
      }
    },
    [state, onStateChange]
  );

  if (!state.show) {
    return null;
  }

  return (
    <div data-testid="activity-transition-manager">
      <ActivityTransitionModal
        activityStatus={state.activityStatus}
        message={state.transitionMessage ?? ""}
        starsEarned={state.starsEarned}
        activityType={state.activityType}
        isLastMasteryCheck={state.isLessonCompleted}
        handleModalClose={handleModalClose}
        avatar={avatar}
        totalScore={state.totalScore}
        takeTotal={state.takeTotal}
        displayScore={state.displayScore}
      />
    </div>
  );
}

export { ActivityTransitionManager, initialState as initialActivityTransitionState };
export default ActivityTransitionManager;
